import { styled } from '@mui/system'
export const PAGE_MAX_WIDTH = 1344 // official max-width plus padding; assumes border-box sizing

export const ContentContainer = styled('main')(({ theme }) => ({
  maxWidth: PAGE_MAX_WIDTH,
  margin: '0 auto',
  [theme.breakpoints.up('sm')]: {
    padding: '0 32px',
  },
}))
